import usePushNotifications from "./usePushNotifications";
import { API, graphqlOperation } from "aws-amplify";
import { updateOrder } from "../graphql/myMutations";
import useToCancelOrders from "./useToCancelOrders";
const useToSendedOrders = () => {
  //funciones del hook para enviar notificaciones
  const { sendOneSignalNotifications } = usePushNotifications();
  const { cancelOrderbyTime } = useToCancelOrders();
  const ID_MERCADITO = "75po9u2m-618o-5701-p811-5y675192847d";
  /**
   *
   * @param {object} order
   */
  const sendReminder = (order, messageAssignOrder) => {
    //La orden cuenta con recordatorios?
    if (order.reminders === undefined) {
      //No cuenta con recordatorios, inicializamos y mandamos el primero
      updateRemindersByOrderID(order.id, [convertUTCDateToLocalDate("date")]);
      sendReminderToSeller(order);
    } else {
      //Cuenta con recordatorios, pasar el JSON a un arreglo
      let db_reminders = JSON.parse(order.reminders);
      if (db_reminders) {
        //? Solo se ha enviado un recordatorio
        if (db_reminders.length === 1) {
          let updated = new Date(db_reminders[0]); //obtenemos fecha del envío
          let today = new Date(convertUTCDateToLocalDate("date")); //fecha actual
          let diference = getTimeDiference(updated, today); //obtenemos los minutos de diferencia
          if (diference >= 3) {
            //? ya han pasado 3min, por lo tanto puede enviarse el segundo recordatorio
            messageAssignOrder(
              "¡Segundo recordatorio!",
              "Se ha enviado recordatorio a " + order.shop_id.shop_name,
              "success"
            );
            db_reminders.push(convertUTCDateToLocalDate("date"));
            updateRemindersByOrderID(order.id, db_reminders);
            sendReminderToSeller(order);
          } else {
            //Aún no han pasado 3 minutos como para enviar el siguiente recordatorio
            messageAssignOrder(
              "¡Espera!",
              "Aún no transcurren 3 minutos desde que enviaste el último recordatorio",
              "warning"
            );
          }
        } else if (db_reminders.length === 2) {
          //? mandar tercer recordatorio
          let updated = new Date(db_reminders[1]);
          let today = new Date(convertUTCDateToLocalDate("date"));
          let diference = getTimeDiference(updated, today);
          if (diference >= 3) {
            const titleMsg =
              order?.shop_id?.id === ID_MERCADITO
                ? "¡Tercer recordatorio!"
                : "¡Último recordatorio!";
            //? mandar último recordatorio
            messageAssignOrder(
              titleMsg,
              "Se ha enviado recordatorio a " + order.shop_id.shop_name,
              "success"
            );
            db_reminders.push(convertUTCDateToLocalDate("date"));
            updateRemindersByOrderID(order.id, db_reminders);
            sendReminderToSeller(order);
          } else {
            //console.log("No ha pasado el tiempo mínimo 3er ", diference);
            messageAssignOrder(
              "¡Espera!",
              "Aún no transcurren 3 minutos desde que enviaste el último recordatorio",
              "warning"
            );
          }
        } else {
          //? ya hay 3 recordatorios
          if (order?.shop_id?.id === ID_MERCADITO && db_reminders.length < 10) {
            //? si es mercadito y las notificaciones enviadas son menores a 10
            let updated = new Date(db_reminders[1]);
            let today = new Date(convertUTCDateToLocalDate("date"));
            let diference = getTimeDiference(updated, today);
            if (diference >= 3) {
              //? mandar recordatorio
              messageAssignOrder(
                sequenceMessage(db_reminders.length + 1),
                "Se ha enviado recordatorio a " + order.shop_id.shop_name,
                "success"
              );
              db_reminders.push(convertUTCDateToLocalDate("date"));
              updateRemindersByOrderID(order.id, db_reminders);
              sendReminderToSeller(order);
            } else {
              //console.log("No ha pasado el tiempo mínimo 3er ", diference);
              messageAssignOrder(
                "¡Espera!",
                "Aún no transcurren 3 minutos desde que enviaste el último recordatorio",
                "warning"
              );
            }
          } else {
            //evaluar la cancelación en caso de que ya haya pasado 1 minuto entre el último recordatorio y la fecha actual
            let updated = new Date(db_reminders[2]);
            let today = new Date(convertUTCDateToLocalDate("date"));
            let diference = getTimeDiference(updated, today);
            if (diference >= 1) {
              //? Ya se han mandado 3 recordatorios (9mins) +1min de espera, procede la cancelación
              if (order.method_pay !== "TARJETA") {
                cancelOrder(order, messageAssignOrder);
              } else {
                messageAssignOrder(
                  "¡Oops!",
                  "La orden no puede ser cancelada, el método de pago es tarjeta",
                  "warning"
                );
              }
            } else {
              //Ya ha llegado a enviar 3 recordatorios, pero aun no pasan los 10 mins como para cancelar la orden
              messageAssignOrder(
                "¡Oops!",
                "Ya has llegado al límite de recordatorios " +
                  order.shop_id.shop_name,
                "warning"
              );
            }
          }
        }
      } else {
        //Mandamos el primer recordatorio
        db_reminders = [];
        db_reminders.push(convertUTCDateToLocalDate("date"));
        updateRemindersByOrderID(order.id, db_reminders);
        sendReminderToSeller(order);
        messageAssignOrder(
          "¡Recordatorio enviado!",
          "Se ha enviado recordatorio a " + order.shop_id.shop_name,
          "success"
        );
      }
    }
  };

  /**
   * Function to know the number of notification in string
   * @param {Number} number número de notificación
   */
  const sequenceMessage = (number) => {
    let message = "";
    switch (number) {
      case 4:
        message = "¡Cuarto recordatorio!";
        break;

      case 5:
        message = "¡Quinto recordatorio!";
        break;

      case 6:
        message = "¡Sexto recordatorio!";
        break;

      case 7:
        message = "¡Septimo recordatorio!";
        break;

      case 8:
        message = "¡Octavo recordatorio!";
        break;

      case 9:
        message = "¡Noveno recordatorio!";
        break;

      case 10:
        message = "¡Último recordatorio!";
        break;

      default:
        message = "¡Recordatorio enviado!";
        break;
    }
    return message;
  };

  const sendReminderToSeller = (order) => {
    sendOneSignalNotifications({
      content:
        "¡" +
        order.shop_id.shop_name +
        " apresúrate!, tienes una orden sin atender",
      title: "Tienes una orden sin atender",
      ids: [order.shop_id.seller_id.id],
      channel: "new-order",
      role: "seller",
    });
  };

  function getTimeDiference(updated, today) {
    let diffMs = today - updated; // milliseconds between now & Christmas
    //let days = Math.floor(diffMs / 86400000); // days
    let hours = Math.floor((diffMs % 86400000) / 3600000); // hours
    let minutes = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    var seconds = Math.round((((diffMs % 86400000) % 3600000) % 60000) / 1000); // seconds

    return (hours * 60 * 60 + minutes * 60 + seconds) / 60;
  }

  /*Función que para la hora actual (UTC) del sistema a la hora local
    Retorna un objeto que contiene la hora y minutos(int) para posteriormente 
    validar los rangos de horarios*/
  function convertUTCDateToLocalDate(type) {
    var newDate = new Date();
    //console.log("Fecha actual: ", newDate);
    newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
    var currentDateToString = newDate.toISOString();

    var myHour = {
      hour: parseInt(currentDateToString.substring(11, 13)),
      minutes: parseInt(currentDateToString.substring(14, 16)),
      type: parseInt(currentDateToString.substring(11, 13)) < 12 ? "am" : "pm",
    };
    //return myHour;
    if (type === "date") return currentDateToString;
    else return myHour;
  }

  const updateRemindersByOrderID = async (orderId, history) => {
    try {
      let info = {
        id: orderId,
        reminders: JSON.stringify(history),
      };
      await API.graphql(graphqlOperation(updateOrder, { input: info }));
    } catch (error) {
      console.log("Error al actualizar el historial de recordatorios", error);
    }
  };

  const cancelOrder = (order, messageAssignOrder) => {
    //console.log("Cancelar orden-->", order.id);
    messageAssignOrder(
      "Orden cancelada",
      "Se ha cancelado la orden, la tienda no ha contestado",
      "warning"
    );
    cancelOrderbyTime(order);
  };

  return { cancelOrder, sendReminder };
};

export default useToSendedOrders;
